declare namespace $ {

	type $mol_button_minor__title_shm_hitalama_chat_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_chat_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chat['logs_clear'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_shm_hitalama_chat_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chat['message_author'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_hitalama_chat_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chat['message_date'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_shm_hitalama_chat_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_hitalama_chat_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chat['message_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_textarea__value_shm_hitalama_chat_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chat['draft'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__submit_shm_hitalama_chat_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chat['send'] >
		,
		ReturnType< $mol_textarea['submit'] >
	>
	type $mol_button_minor__sub_shm_hitalama_chat_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_chat_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chat['send'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_card__sub_shm_hitalama_chat_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['sub'] >
	>
	export class $shm_hitalama_chat extends $shm_hitalama_page {
		logs_clear( next?: any ): any
		Logs_clear( ): $mol_button_minor
		messages( ): readonly(any)[]
		message_author( id: any): string
		Message_author( id: any): $mol_paragraph
		message_date( id: any): string
		Message_date( id: any): $mol_paragraph
		Message_head( id: any): $mol_view
		message_text( id: any): string
		Message_text( id: any): $mol_text
		draft( next?: string ): string
		send( next?: any ): any
		Textarea( ): $mol_textarea
		Send_icon( ): $mol_icon_send
		Send( ): $mol_button_minor
		resize_side( ): string
		title( ): string
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		Message( id: any): $mol_card
		foot( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=chat.view.tree.d.ts.map